var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocscomponent = function SvgDocscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.083 12.643h-9.666V2.929h-14.5V32.07h24.166V12.643Zm-.98-2.429-6.27-6.3v6.3h6.27ZM1.707.5h18.125l9.667 9.714v23.072c0 .354-.113.645-.34.873-.226.227-.515.341-.868.341H1.708c-.353 0-.642-.114-.868-.341-.227-.228-.34-.519-.34-.873V1.714c0-.354.113-.645.34-.873C1.066.614 1.355.5 1.708.5Zm6.042 17h14.5v2.429H7.75V17.5Zm0-7.286h6.042v2.429H7.75v-2.429Zm0 14.572h14.5v2.428H7.75v-2.428Z",
    fill: "current"
  })));
};
export default SvgDocscomponent;